import { z } from 'zod';
import { eventEmitter } from '@/lib/eventEmitter.ts';

const HotkeyPressValueSchema = z.object({
    screenCaptureData: z.string().optional(),
    screenCaptureCount: z.number().default(1),
});

export const showSolvePreviewHandler = (rawValue: object) => {
    const value = HotkeyPressValueSchema.parse(rawValue);

    eventEmitter.emit('showScreenCapturePreview', {
        screenCaptureData: value.screenCaptureData,
        screenCaptureCount: value.screenCaptureCount,
    });
};
